import axios from '../utils/axios';

export default function downloadCourseEnquiry(adminId,courseId,params) {
    return (
        axios.get('/admin/' + adminId +'/courses/course/' + courseId + '/leads/download',  {
            responseType: 'arraybuffer',
            params} )
    )
}